var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"auth-modal",attrs:{"name":"modal-card","width":"500px","height":"360px","adaptive":true,"clickToClose":false}},[_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }